// Shared JSON-LD builders — used by both the React app and scripts/prerender.js (CJS)
const BASE_URL = "https://bestspinesurgeonhyderabad.com";
const PHYSICIAN_ID = `${BASE_URL}/#physician`;

const todayISO = () => new Date().toISOString().slice(0, 10);

const aboutFor = (page) => {
  if (page.type === "condition") {
    return { "@type": "MedicalCondition", name: page.entityName || page.h1 };
  }
  if (page.type === "procedure") {
    return {
      "@type": "MedicalProcedure",
      name: page.entityName || page.h1,
      procedureType: "https://schema.org/SurgicalProcedure",
    };
  }
  if (page.type === "profile") {
    return { "@id": PHYSICIAN_ID };
  }
  return null;
};

// Condition / procedure / profile pages: MedicalWebPage + FAQPage + BreadcrumbList
const pageSchemas = (page) => {
  const url = `${BASE_URL}/${page.slug}`;
  const about = aboutFor(page);
  const crumbs = [{ "@type": "ListItem", position: 1, name: "Home", item: `${BASE_URL}/` }];
  if (page.breadcrumbParent) {
    crumbs.push({
      "@type": "ListItem",
      position: 2,
      name: page.breadcrumbParent.name,
      item: `${BASE_URL}${page.breadcrumbParent.path}`,
    });
  }
  crumbs.push({ "@type": "ListItem", position: crumbs.length + 1, name: page.breadcrumbLabel || page.h1, item: url });
  const webPage = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "@id": url,
    url,
    name: page.metaTitle,
    headline: page.h1,
    description: page.metaDescription,
    reviewedBy: { "@id": PHYSICIAN_ID },
    lastReviewed: todayISO(),
  };
  if (about) webPage.about = about;
  return [
    webPage,
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: page.faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: crumbs,
    },
  ];
};

// Blog posts: BlogPosting + BreadcrumbList
const postSchemas = (post) => {
  const url = `${BASE_URL}/blog/${post.slug}`;
  return [
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "@id": url,
      mainEntityOfPage: url,
      headline: post.title,
      description: post.metaDescription,
      image: post.image,
      datePublished: post.dateISO,
      dateModified: post.dateModifiedISO || post.dateISO,
      author: { "@id": PHYSICIAN_ID },
      publisher: { "@id": PHYSICIAN_ID },
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${BASE_URL}/` },
        { "@type": "ListItem", position: 2, name: "Blog", item: `${BASE_URL}/blog` },
        { "@type": "ListItem", position: 3, name: post.title, item: url },
      ],
    },
  ];
};

const removePrerenderedSchemas = () => {
  if (typeof document === "undefined") return;
  document
    .querySelectorAll('script[data-prerendered="true"]')
    .forEach((n) => n.remove());
};

module.exports = { BASE_URL, PHYSICIAN_ID, pageSchemas, postSchemas, removePrerenderedSchemas };
